import React from 'react';

const CardSkeleton = () => {
  return (
    <div className="card-skeleton">
      <div className="skeleton-header">
        <div className="skeleton-icon"></div>
        <div className="skeleton-text skeleton-title"></div>
      </div>
      <div className="skeleton-text skeleton-subtitle"></div>
      <div className="skeleton-text skeleton-line"></div>
      <div className="skeleton-text skeleton-line"></div>
    </div>
  );
};

export default CardSkeleton;
